import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtilsV2 } from '@shared/utils';
import {
  RequestStrategyEnum,
  TransferRequestsApi,
  type TransferRequestGetListRequest,
  type TransferRequestResponse,
  type WithSignal,
} from '@shared/api';

const getTransfersEffect = createEffect(({ signal, ...request }: WithSignal<TransferRequestGetListRequest> = {}) =>
  TransferRequestsApi.getList(request, signal),
);
const clearEvent = createEvent();

const $dataStore = createStore<{ total: number; data: TransferRequestResponse[] }>({ data: [], total: 0 })
  .on(getTransfersEffect.done, (_, data) => (data.result ? { total: data.result.total, data: data.result.data || [] } : { total: 0, data: [] }))
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getTransfersEffect.pending, (_, data) => data)
  .on(getTransfersEffect.fail, (_, data) => ApiUtilsV2.abortApiLoadingFailCaseTrigger(data.error))
  .on(getTransfersEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getTransfersEffect, () => null)
  // .on(getTransfersEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getTransfersEffect.fail, () => 'Something went wrong while fetching Approve Pending Transactions. Please try again.')
  .on(getTransfersEffect.done, () => null)
  .reset(clearEvent);

const getTransfersApi = ApiUtilsV2.wrapperApi(getTransfersEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getTransfersApi.cancel());

export const $transferRequestsApprovedListStore = {
  events: {
    getTransfers: getTransfersApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
